"use strict";

exports.__esModule = true;
exports.default = exports.initState = void 0;

var _auth = require("../utils/auth");

const initState = {
  auth: {
    isAuthorised: (0, _auth.isAuthorised)()
  }
};
exports.initState = initState;
var _default = initState;
exports.default = _default;